import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";
import { BUTTON, ROUTES, UI_TEXT } from "../../constants";

const PageNotFound = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

	const handleGoHome = () => {
		navigate(ROUTES.HOME); // Replace with your desired route
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "40vh",
				textAlign: "center",
				p: 3,
			}}>
			<ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
			<Typography variant="h4" color="textPrimary" gutterBottom>
				{t('UI_TEXT.PAGE_NOT_FOUND_ERROR')}
			</Typography>
			<Typography variant="body1" color="textSecondary" gutterBottom>
				{t('UI_TEXT.PAGE_NOT_FOUND_DESCRIPTION')}
			</Typography>
			<Button variant="contained" color="primary" onClick={handleGoHome} sx={{ mt: 2 }}>
				{t('BUTTON.GO_TO_HOMEPAGE')}
			</Button>
		</Box>
	);
};

export default PageNotFound;
